export default __webpack_public_path__ + "static/media/logo_icona.2ce29e1e.png";